import { useProjectParams } from '@hooks/useProjectParams';
import { Toolbar } from 'components/Toolbar';
import { BimContractStatusEnum, ProjectStatusEnum } from 'gql/graphql';
import { useAccess } from 'hooks/useAccess';
import { useHandleEditContract } from 'hooks/useHandlersContract';
import { useCreateBimOrder } from 'pages/Project/BimProject/hooks/useCreateBimOrder';
import { Button, cnMixSpace } from 'uikit';

import type React from 'react';

interface IBimContractToolbar {
    projectId?: string;
    statusProject?: ProjectStatusEnum;
    statusContract?: BimContractStatusEnum;
}

export const BimContractToolbar: React.FC<IBimContractToolbar> = (props) => {
    const { projectId, statusProject, statusContract } = props;
    const { methodology } = useProjectParams();
    const { contract: contractRules, order: orderRules } = useAccess();
    const handleEditClick = useHandleEditContract(projectId, methodology);

    const isContractStatusCompleted = statusContract === BimContractStatusEnum.Completed;
    const isContractStatusDelayed = statusContract === BimContractStatusEnum.Delayed;

    const isProjectStatusDelayed = statusProject === ProjectStatusEnum.Delayed;
    const isProjectStatusCompleted = statusProject === ProjectStatusEnum.Completed;

    const isDisabledByProjectStatus = isProjectStatusDelayed || isProjectStatusCompleted;

    const { orderCreateBtnTitle, createBimOrderHandler, CreateOrderConfirmationDialog, isOrderCreateDisabled } =
        useCreateBimOrder({
            projectId,
        });

    return (
        <Toolbar>
            <Button
                label="Редактировать"
                view="secondary"
                size="s"
                onClick={handleEditClick}
                className={cnMixSpace({ mR: 's' })}
                disabled={!contractRules.canEdit || isDisabledByProjectStatus || isContractStatusCompleted}
            />

            <Button
                label={orderCreateBtnTitle}
                size="s"
                className={cnMixSpace({ mR: 's' })}
                onClick={createBimOrderHandler}
                disabled={
                    !orderRules.canCreate ||
                    isDisabledByProjectStatus ||
                    isContractStatusCompleted ||
                    isContractStatusDelayed ||
                    isOrderCreateDisabled
                }
            />

            {CreateOrderConfirmationDialog}
        </Toolbar>
    );
};

BimContractToolbar.displayName = 'BimContractToolbar';
